type TUuidCrypto = Crypto & {
    randomUUID?: () => string,
};

export default function createClientMessageId(): string {
    const cryptoApi = window.crypto as TUuidCrypto|undefined;
    if (cryptoApi?.randomUUID !== undefined) {
        return cryptoApi.randomUUID();
    }

    const bytes = new Uint8Array(16);
    if (cryptoApi?.getRandomValues !== undefined) {
        cryptoApi.getRandomValues(bytes);
    } else {
        for (let index = 0; index < bytes.length; index++) {
            bytes[index] = Math.floor(Math.random() * 256);
        }
    }
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;

    const value = Array.from(bytes, byte => byte.toString(16).padStart(2, "0")).join("");

    return `${value.slice(0, 8)}-${value.slice(8, 12)}-${value.slice(12, 16)}`
        + `-${value.slice(16, 20)}-${value.slice(20)}`;
}
